/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Table,
  Modal,
  Spinner,
} from 'reactstrap';
import * as moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { getUploadHistory, getFileDownloadLink } from '../../../actions/batch';

import LoaderButton from '../../common/LoaderButton';

class HistoryModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      nLoading: false,
      pLoading: false,
      page: 1,
      totalPages: 1,
    };
  }

  componentDidUpdate({ isOpen: wasOpen }) {
    const { isOpen, loadHistory } = this.props;
    const { page } = this.state;

    // Refresh history when opening modal.
    if (isOpen && wasOpen !== isOpen) {
      getUploadHistory(page).then(({ data }) => {
        const {
          BatchUpdates = [],
          Page,
          TotalPages,
        } = data;

        this.setState({
          page: Page,
          totalPages: TotalPages,
        });

        loadHistory(BatchUpdates);
      });
    }
  }

  nextClick = () => {
    const { loadHistory } = this.props;
    const { page, totalPages } = this.state;

    this.setState({ nLoading: true });

    getUploadHistory(page + 1).then(({ data }) => {
      console.log(data);
      const {
        BatchUpdates = [],
        Page,
        TotalPages,
      } = data;

      this.setState({
        page: Page,
        totalPages: TotalPages,
        nLoading: false,
      });

      loadHistory(BatchUpdates);
    }).catch(() => this.setState({ nLoading: false }));
  }

  prevClick = () => {
    const { loadHistory } = this.props;
    const { page, totalPages } = this.state;

    this.setState({ pLoading: true });

    getUploadHistory(page - 1).then(({ data }) => {
      const {
        BatchUpdates = [],
        Page,
        TotalPages,
      } = data;

      this.setState({
        page: Page,
        totalPages: TotalPages,
        pLoading: false,
      });

      loadHistory(BatchUpdates);
    }).catch(() => this.setState({ pLoading: false }));
  }

  downloadFile = (id) => {
    getFileDownloadLink(id).then((res) => {
      console.log(res.headers);
      const { 'content-disposition': cd } = res.headers;
      const re = /filename[^;=\n]*="(.*?\2|[^;\n]*)"/g;
      const group = re.exec(cd);
      let filename = `${Date.now()}.csv`;
      if (cd) {
        filename = group[1];
      }
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    });

  }

  render() {
    const { isOpen, history, close } = this.props;
    const {
      page,
      totalPages,
      nLoading,
      pLoading,
    } = this.state;

    return (
      <Modal
        isOpen={isOpen}
        toggle={close}
        zIndex="100000"
        style={{ maxWidth: '95%', height: '92vh' }}
        contentClassName="h-100 overflow-auto p-4"
      >
        <div className="d-flex">
          <h1>Upload History</h1>
          <Button color="white" className="ms-auto rounded-pill" onClick={close}>
            <FontAwesomeIcon fixedWidth icon={faTimes} size="2x" />
          </Button>
        </div>
        {history.length ? (
          <Table bordered striped className="text-monospace text-small mt-3">
            <thead>
              <tr>
                <th>Upload Date</th>
                <th>Category</th>
                <th>Type</th>
                <th>User</th>
                <th>Upload File</th>
                <th>Results</th>
                <th>Rows Added</th>
                <th>Rows Updated</th>
              </tr>
            </thead>
            <tbody>
              {history.map((file) => (
                <tr key={file.created}>
                  <td>{moment(file.created).format('MM/DD/YYYY hh:mm:ssa')}</td>
                  <td>{file.file_type || file.diff.file_type}</td>
                  <td
                    className={[
                      file.step === 'process' ? 'bg-danger' : '',
                      file.step === 'preview' ? 'bg-secondary' : '',
                    ].join(' ')}
                  >
                    {file.step}
                  </td>
                  <td>{file.created_by_email}</td>
                  <td>{file.file_name}</td>
                  <td>
                    {(['leads', 'leads_reassignment'].includes(file.file_type) && file.has_async_response)
                      ? (
                        <a href="#" onClick={() => this.downloadFile(file.id)}>
                          download
                        </a>)
                      : ( 'N/A' )}
                  </td>
                  <td>{file.rows_created}</td>
                  <td>{file.rows_updated}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            <Spinner color="dark" type="grow" style={{ width: '8rem', height: '8rem' }} />
            <Spinner color="dark" type="grow" style={{ width: '8rem', height: '8rem' }} />
            <Spinner color="dark" type="grow" style={{ width: '8rem', height: '8rem' }} />
          </div>
        )}
        <div className="row justify-content-center">
          <LoaderButton
            className="btn btn-secondary"
            style={{ width: '120px' }}
            type="button"
            text="Previous"
            loading={pLoading}
            disabled={nLoading}
            onClick={this.prevClick}
          />
          <div className="d-flex align-items-center mx-4">
            {page} of {totalPages}
          </div>
          <LoaderButton
            className="btn btn-secondary"
            style={{ width: '120px' }}
            type="button"
            text="Next"
            loading={nLoading}
            disabled={pLoading}
            onClick={this.nextClick}
          />
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (store) => ({
  isOpen: store.modals.historyOpen,
  history: store.batch.history,
});

const mapDispatchToProps = {
  close: () => ({ type: 'CLOSE_MODAL', modal: 'historyOpen' }),
  loadHistory: (history) => ({ type: 'LOAD_BATCH_HISTORY', history }),
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryModal);
